import React from 'react';

import { Text } from '@betterment/samba-react';
import { Button, Modal } from '@betterment/style-closet-react';

import { HandleCategoryUpdate } from './data';

import { DetailedTransaction } from '../../data';
import { TransactionCategory } from '../TransactionIcon';

interface Props {
  transaction: DetailedTransaction;
  accountRuleElgibileCategory: TransactionCategory;
  handleCategoryUpdate: HandleCategoryUpdate;
  onClose: () => void;
}

const CategoryUpdateConfirmationModal: React.FC<React.PropsWithChildren<Props>> = ({
  transaction,
  accountRuleElgibileCategory,
  handleCategoryUpdate,
  onClose,
}) => {
  const onClick = async (shouldCreateRule: boolean) => {
    await handleCategoryUpdate({ category: accountRuleElgibileCategory, shouldCreateRule });
    onClose();
  };

  return (
    <Modal
      label="transaction category update confirmation"
      contentWidth={['100%', '480px']}
      variant="new"
      closeHandler={() => {
        void onClick(false);
        onClose();
      }}
    >
      <Modal.Slot name="heading">Apply this category to future transactions?</Modal.Slot>
      <Modal.Slot name="content">
        <Text as="p">
          Would you like us to categorize all future {transaction.merchant?.name ?? ''} transactions as{' '}
          {accountRuleElgibileCategory}?
        </Text>
      </Modal.Slot>
      <Modal.Slot name="actions">
        <Button onClick={() => onClick(true)}>Yes, always apply</Button>
        <Button variant="secondary" onClick={() => onClick(false)}>
          No, only once
        </Button>
      </Modal.Slot>
    </Modal>
  );
};

export default CategoryUpdateConfirmationModal;
